import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { resetState, goToPage, validateMailHandler, changeMailHandler, setTimeDisconnectOccurred, disconnectProduct } from '../../DisconnectServiceSlice'
import images from '../../DisconnectPhotos/images'
import BtnWhite from '../../../../Shared/Buttons/BtnWhite';
import { Container, Row, Col } from 'reactstrap';
import gaParams from '../../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../../utilities/analytics/tracking';
import { isBrowser } from "react-device-detect";

function SummaryAfterFailedDelivery(props) {

    const [isShowOther, setIsShowOther] = useState(false)
    const [deliveryError, SetDeliveryError] = useState(true);

    useEffect(() => {
        if (typeof window.scrollTo === "function") { 
            window.scrollTo(0, 0);
        } 
        gaEvent(gaParams.DISCONNECT_SHOW_BOX_WE_DONE_DISCONNECT_BUT_FAILED_DELIVERY.category, gaParams.DISCONNECT_SHOW_BOX_WE_DONE_DISCONNECT_BUT_FAILED_DELIVERY.eventType, props.serviceToDisconnect.serviceType)
      }, [])

    const days = ['יום א', 'יום ב', 'יום ג', 'יום ד', 'יום ה', 'יום ו', 'יום ש'];
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();
    today = dd + '.' + mm + '.' + yyyy;

    const todayFull = new Date();
    const todayStr = `${String(todayFull.getDate()).padStart(2, '0')}/${String(todayFull.getMonth() + 1).padStart(2, '0')}/${todayFull.getFullYear()}`;
    const dayName = days[todayFull.getDay()];
    const displayFullDay = todayStr + ' ' + dayName;

    function closeItemsPopUp() {
        setIsShowOther(!isShowOther)
    }

    function getKits(kit) {
        let kitProducts = [];
        if(kit.kitProducts && kit.kitProducts.length > 0) {
            kitProducts = kit.kitProducts.map(function(kitProduct, index){
                let equipment = (props.equipmentList || []).find(function(equ){
                    return equ.id.value === kitProduct.productId
                })
                if(equipment) {
                    // Take image
                    return (
                    <div key={index} className="equipmentBox">
                        <div className="equipmentDetails">
                            <div>{equipment.description.value}</div>
                            <Image className="img" alt="equipment" src={Config.epiBaseUrl + equipment.photoSmall.value.url} />
                        </div>
                    </div> )  
                }
                else {
                    // default img
                    return (
                        <div key={index} className="equipmentBox">
                            <div className="equipmentDetails">
                                <div>{kitProduct.title}</div>
                                <Image alt="not found" src={images.default} className="img" /> 
                            </div>
                        </div> 
                    )  
                }
            })
        }
        return kitProducts;
    }

    const kits = props.equipmentForProductData.kitList.map(function(kit, index){
        return <Row key={index} className="equipment-row">
                    <div className="equipment-info-header">{kit.counter > 1 ? `${kit.counter} ${kit.kitTitle}`: `${kit.kitTitle}`}</div>
                    {kit.counter > 1 ? <span className="span-txt">עבור כל אחד יש להחזיר: </span> : <span className="span-txt">עבורו יש להחזיר: </span>}
                    {getKits(kit)}
                </Row>
    })

    function displayAllItemsToReturn() {
        setIsShowOther(!isShowOther);
    }

    async function goBackHome() {
        var content = await props.context.loadContentByPath(props.redirectTo);
        props.context.navigateTo(content);
    }

    return (
        <Container className="SummaryAfterFailedDelivery-root"> 
            <Row className="header-row">
                <h3 className="header">סיכום פרטי הניתוק</h3>
                <h5 className="v-header">תודה שהיית איתנו</h5>
            </Row>
            <Row className="user-summary-number-row">
                <Col>
                    <div className="detail"><span className="txt">מספר אסמכתא: </span>{props.writtenProofNumber}</div>
                </Col>
            </Row>
            {isBrowser ? 
            <Row className="user-details-row">
                <Col>
                    <div className="detail"><span className="txt">ת.ז: </span>{props.UserInfo.IDNumber}</div>
                </Col>
                <Col>
                    <div className="detail"><span className="txt">שם לקוח: </span>{props.UserInfo.firstName} {props.UserInfo.lastName}</div>
                </Col> 
                <Col>
                    <div className="detail"><span className="txt">תאריך: </span>{today}</div>
                </Col>
            </Row>
            :
            <>
            <Row className="user-details-row">
                <Col className="pl-1 pr-1">
                    <div className="detail"><span className="txt">שם לקוח: </span>{props.UserInfo.firstName} {props.UserInfo.lastName}</div>
                </Col> 
                <Col className="pl-0 pr-0">
                    <div className="detail"><span className="txt">תאריך: </span>{today}</div>
                </Col>
                
            </Row>
            <Row className="user-details-row-second">
                <Col className="pl-0 pr-0">
                    <div className="detail"><span className="txt">ת.ז: </span>{props.UserInfo.IDNumber}</div>
                </Col>
            </Row>
            </>
            }
            <Row className="service-disconnect-summary-row">
                <div className="service-disconnect-summary">
                    <h6 className="header">ניתוק מ: {props.serviceToDisconnect.title}</h6>
                    <div className="header-sub-txt">{props.serviceToDisconnect.email}</div>
                    <div className="header-sub-txt">מספר הלקוח: {props.serviceToDisconnect.customerId}</div>
                    <div className="header-sub-txt">בכתובת: {props.serviceToDisconnect.address}</div>
                    <div>
                        <h6 className="header">הניתוק ייכנס לתוקף בתאריך</h6>
                        <div className="header-sub-txt">{displayFullDay}</div>
                    </div>
                </div>
            </Row>
            <Row className="equipment-to-return-row"> 
                <div className="service-disconnect-summary">
                    <h6 className="header">רשימת הציוד להחזרה</h6>
                    <div className="header-sub-txt">תאריך אחרון להחזרה הינו ה - {props.equipmentForProductData.returnDay} <br/>אי החזרה הציוד תהיה כרוכה בתשלום העלות שלו.</div>
                    <div onClick={() => displayAllItemsToReturn()} className="linkTo">לצפייה ברשימה
                        <div className="arrow"/>
                    </div>
                    <PopUp showPopUp={isShowOther} onClose={closeItemsPopUp}>
                        <div className="kitPopUpContainer">
                            <h3 className="kit-header">רשימת הציוד להחזרה</h3>
                            <div className="kit-list-container">{kits}</div>
                        </div>
                    </PopUp>
                </div>
            </Row>
            {props.finalDisconnectResponse === true && props.emailInStore.email !== "" ? 
                <div className="mail-msg" style={{fontWeight: 'bold', marginTop: '10px'}}>נשלח את הפרטים למייל שהזנת</div> : null
            }
            {deliveryError == false ? null :
            <Row className="failedDelivery-row">
                <div className="txt-container">
                    <div className="pink-txt">השליחות להחזרת הציוד לא תואמה</div>
                    <div className="regular-txt">נחזור אליך בקרוב לקביעת מועד לשליחות</div>
                </div>
            </Row>}
            <Row className="btn-row">
                <BtnWhite text={'סיום'} onclick={() => goBackHome()}/>
            </Row>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    stepParams: state.disconnectServicesBlock.stepParams,
    serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect,
    deliverTo: state.addressForm.form,
    reasons: state.disconnectServicesBlock.summarizeUserDisconnectDetails,
    time: state.disconnectServicesBlock.summarizeUserDisconnectDetails.timeDisconnectScheduled,
    UserInfo: state.authentication.loginData.userDetails,
    equipmentForProductData: state.disconnectServicesBlock.equipmentForProductData,
    mailForm: state.disconnectServicesBlock.summarizeUserDisconnectDetails,
    notes: state.disconnectServicesBlock.summarizeUserDisconnectDetails.deliveryNotes,
    codes: state.disconnectServicesBlock.summarizeUserDisconnectDetails.deliveryCodes,
    finalDisconnectResponse: state.disconnectServicesBlock.finalDisconnectResponse,
    deliverySet: state.disconnectServicesBlock.deliverySet,
    deliveryMobile: state.disconnectServicesBlock.MobileToGetBackTo,
    writtenProofNumber: state.disconnectServicesBlock.writtenProofNumber,
    emailInStore: state.disconnectServicesBlock.summarizeUserDisconnectDetails.emailForm,
    method: state.disconnectServicesBlock.summarizeUserDisconnectDetails.equipmentReturnMethod
});
  
const mapDispatchToProps = {
    goToPage,
    setTimeDisconnectOccurred,
    changeMailHandler,
    validateMailHandler,
    disconnectProduct,
    resetState
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryAfterFailedDelivery);